module.exports = __webpack_public_path__ + "img/dan3.a7a1769d.png";